import { useTranslation } from '@frontend/i18n';
import { settingsTrackingIds } from '@frontend/schedule-helpers';
import { useAppScopeStore } from '@frontend/scope';
import { SettingsLink, useSettingsNavigate } from '@frontend/settings-routing';
import { SettingsGroup } from '@frontend/settings-ui';
import { IndexRow } from '@frontend/design-system';
import { useSchedulingLocationInfo } from '../../hooks/use-scheduling-location-info';

export const MultiLocationCancellationPolicySettings = () => {
  const { navigate } = useSettingsNavigate();
  const { t } = useTranslation('schedule-settings');
  const { getScopeName } = useAppScopeStore();
  const { getOnlineSchedulingReadyLocationIds } = useSchedulingLocationInfo();
  const onlineSchedulingReadyLocationIds = getOnlineSchedulingReadyLocationIds();

  const navigateTo = (locationId: string) => {
    navigate({
      to: '/schedule/cancellation-policy/:locationId',
      params: { locationId: locationId ?? '' },
    });
  };

  return (
    <SettingsGroup title={t('Location Settings')}>
      <IndexRow>
        {onlineSchedulingReadyLocationIds.map((locationId) => (
          <IndexRow.Item
            key={locationId}
            as={SettingsLink}
            to='/schedule/cancellation-policy/:locationId'
            onClick={() => navigateTo(locationId)}
            trackingId={settingsTrackingIds.cancellationPolicyRowItem}
          >
            <IndexRow.Item.Title>{getScopeName(locationId)}</IndexRow.Item.Title>
          </IndexRow.Item>
        ))}
      </IndexRow>
    </SettingsGroup>
  );
};
